module.exports = __webpack_public_path__ + "img/5.a27f25bf.jpg";